import { common } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function severCheckInfo(option) {
  return common.post('serverCheckInfo.do', option)
  .then((res) => {
      return res;
    //return checkLimitedUser(res)
  });
}

export { severCheckInfo }